import React, { useEffect} from 'react';
import { formatISO, startOfWeek, endOfWeek } from 'date-fns';

import ProductCard from '../../../../containers/POS/Items/Products';
import { BookingDescription } from '../../Components/Booking/BookingDescription';
import { ErrorDiv } from './ErrorDiv';


import Locations from '../../../../api/Locations';
import Services from '../../../../api/Services';

export const SelectService=({
    setServices,
    services,
    activeService,
    getEventConflicts,
    handleError,
    setBlocks,
    setSelectedLocation,
    setActiveService,
    checkServiceAndUserTokens,
    userTokens,
    selectedBookings,
    errors,
    ...props
})=>{

    useEffect(() => {
        const getServices = async ()=>{
            try{
                let response = await Services.get({
                    start_date: formatISO(new Date()),
                    max_record: 99,
                    include_deleted: false,
                    search_words: null
                })
                if(response.data && response.status === 200) setServices(response.data.services);
                else if (response.errors) handleError("general", response.errors)
                else handleError("general", "Unknown error getting services")
            }catch(ex){
                console.error(ex)
            }
        }

        getServices();

    /*eslint-disable-next-line */
    },[]);

    const handleServiceSelect=(service)=>{
        setBlocks(service);
        getLocations(service);
    }

    //get the locations for things like name after selecting the active service
    const getLocations=async(service)=>{
        service.locations = [];
        let locations;
        try{
            let response = await Locations.get() //endpoint can only do one at a time, doesn't work with an array of ids so we get them all and filter
            if(response.data && response.status === 200) {
                locations = response.data.filter(location => service.location_ids.includes(location.id));
                service.location_info = locations;
                setSelectedLocation(locations[0]); //If there are multiple, we'll just start with the first one because it can be changed anyway
                await getEventConflicts(service.blocks, locations[0].id);
                setActiveService(service);
                checkServiceAndUserTokens(userTokens, service.products, selectedBookings)
            }
            else if (response.errors) handleError("general", response.errors)
            else handleError("general", "Unknown error getting locations")
        }catch(ex){
            handleError("general", ex)
        }
    }


    return(
        <>
            <div className="d-flex flex-column">
                {activeService &&
                    <div>
                        <BookingDescription 
                            service={activeService}
                            tokens={[]}
                            linkToBundles={null}
                        />
                        <hr />
                    </div>
                }
                <div className="d-flex flex-row flex-wrap">
                    {services?.length > 0 &&
                        services?.map((service)=>{
                            let price;
                            if (service?.products?.length === 1) price = service?.products[0]?.variants[0]?.price;
                            else if (service?.products?.length > 1) price = service?.products.map(product => product.variants[0].price);
                            return(
                                <ProductCard 
                                    key={`service-${service.id}`}   
                                    item={service}
                                    type={0}
                                    name={service?.name}
                                    price={price}
                                    click={()=>handleServiceSelect(service)}
                                />
                            )
                        })
                    }
                </div>
            </div>
            <ErrorDiv errors={errors} />
        </>
    )
}